/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const CHANGE_INPUT = 'app/Register/Main/CHANGE_INPUT';
export const CHANGE_INPUT_ERROR = 'app/Register/Main/CHANGE_INPUT_ERROR';
export const CHANGE_STEP = 'app/Register/Main/CHANGE_STEP';

export const REGISTER_GUIDED_STEP_FOUR = 'app/Register/Main/REGISTER_GUIDED_STEP_FOUR';
export const REGISTER_GUIDED_STEP_FOUR_FAILURE = 'app/Register/Main/REGISTER_GUIDED_STEP_FOUR_FAILURE';
export const REGISTER_GUIDED_STEP_FOUR_SUCCESS = 'app/Register/Main/REGISTER_GUIDED_STEP_FOUR_SUCCESS';
export const REGISTER_GUIDED_STEP_FOUR_VALIDATION_FAILURE = 'app/Register/Main/REGISTER_GUIDED_STEP_FOUR_VALIDATION_FAILURE';

export const REGISTER_GUIDED_STEP_THREE = 'app/Register/Main/REGISTER_GUIDED_STEP_THREE';
export const REGISTER_GUIDED_STEP_THREE_FAILURE = 'app/Register/Main/REGISTER_GUIDED_STEP_THREE_FAILURE';
export const REGISTER_GUIDED_STEP_THREE_SUCCESS = 'app/Register/Main/REGISTER_GUIDED_STEP_THREE_SUCCESS';

export const REGISTER_RESEND_CHANGE_EMAIL = 'app/Register/Main/REGISTER_RESEND_CHANGE_EMAIL';
export const REGISTER_RESEND_EMAIL = 'app/Register/Main/REGISTER_RESEND_EMAIL';
export const REGISTER_RESEND_EMAIL_FAILURE = 'app/Register/Main/REGISTER_RESEND_EMAIL_FAILURE';
export const REGISTER_RESEND_EMAIL_SUCCESS = 'app/Register/Main/REGISTER_RESEND_EMAIL_SUCCESS';
export const REGISTER_RESEND_EMAIL_VALIDATION_FAILURE = 'app/Register/Main/REGISTER_RESEND_EMAIL_VALIDATION_FAILURE';

export const REGISTER_STEP_ONE = 'app/Register/Main/REGISTER_STEP_ONE';
export const REGISTER_STEP_ONE_FAILURE = 'app/Register/Main/REGISTER_STEP_ONE_FAILURE';
export const REGISTER_STEP_ONE_SUCCESS = 'app/Register/Main/REGISTER_STEP_ONE_SUCCESS';

export const REGISTER_STEP_TWO = 'app/Register/Main/REGISTER_STEP_TWO';
export const REGISTER_STEP_TWO_FAILURE = 'app/Register/Main/REGISTER_STEP_TWO_FAILURE';
export const REGISTER_STEP_TWO_SUCCESS = 'app/Register/Main/REGISTER_STEP_TWO_SUCCESS';
export const REGISTER_STEP_TWO_VALIDATION_FAILURE = 'app/Register/Main/REGISTER_STEP_TWO_VALIDATION_FAILURE';

export const REGISTER_VERIFY = 'app/Register/Main/REGISTER_VERIFY';
export const REGISTER_VERIFY_FAILURE = 'app/Register/Main/REGISTER_VERIFY_FAILURE';
export const REGISTER_VERIFY_SUCCESS = 'app/Register/Main/REGISTER_VERIFY_SUCCESS';

export const RESET_INPUTS = 'app/Register/Main/RESET_INPUTS';
export const RESET_INPUT_ERRORS = 'app/Register/Main/RESET_INPUT_ERRORS';
export const RESET_STATE = 'app/Register/Main/RESET_STATE';
export const UPDATE_REGISTER_CURRENT_EMAIL = 'app/Register/Main/UPDATE_REGISTER_CURRENT_EMAIL';

export const VERIFY_RECAPTCHA = 'app/Register/Main/VERIFY_RECAPTCHA';
export const VERIFY_RECAPTCHA_FAILURE = 'app/Register/Main/VERIFY_RECAPTCHA_FAILURE';
export const VERIFY_RECAPTCHA_SUCCESS = 'app/Register/Main/VERIFY_RECATPCHA_SUCCESS';

export const ASSISTANCE_ERROR_MESSAGE = 'For assistance, please contact Customer Service.';
export const REGISTER_SERVICE_ERROR = 'An error has occurred while attempting to register your account. Please try again later. If the issue continues to persist, please call Customer Service for assistance.';
export const REGISTER_STEP_ONE_ERROR = 'The loan information you provided doesn\'t match our records. Please try again.';
export const REGISTER_STEP_ONE_SSO_ERROR = "Please complete your registration by accessing your mortgage provider's main online platform.";
export const REGISTER_STEP_TWO_ERROR = `We are unable to register your loan at this time. ${ASSISTANCE_ERROR_MESSAGE}`;
export const REGISTER_SUCCESS_MESSAGE = 'An email will be sent from noreply@yourmortgageonline.com that will provide instructions to complete the registration.';
export const REGISTER_USERNAME_ERROR = 'Please choose a new username. For questions about registering your loan, contact Customer Service.';

export const DEFAULT_REGISTER_ERRORS = {
  defaultErrorsRegisterGuidedStepFour: {
    bannerError: [],
    password: '',
    serviceError: false,
    username: '',
  },
  defaultErrorsRegisterResend: {
    bannerError: [],
    emailAddress: '',
    password: '',
    serviceError: false,
    username: '',
  },
  defaultErrorsRegisterStepOne: {
    bannerError: [],
    loanNumber: '',
    serviceError: false,
    ssnTin: '',
    zipCode: '',
  },
  defaultErrorsRegisterStepTwo: {
    bannerError: [],
    email: '',
    password: '',
    serviceError: false,
    username: '',
  },
};

export const CONFIRMATION_DICTIONARY = {
  bannerError: {
    header: INTL_IDS.REGISTER_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  guidedStepFourError: {
    header: INTL_IDS.REGISTER_GUIDED_STEP_FOUR_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_GUIDED_STEP_FOUR_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  registerChangeEmailError: {
    header: INTL_IDS.REGISTER_CHANGE_EMAIL_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_CHANGE_EMAIL_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
    needsFormatting: true,
    text: 'An error has occurred while attempting to register your account. Please try again later. If the issue continues to persist, please call Customer Service for assistance.',
  },
  serviceError: {
    header: INTL_IDS.REGISTER_SERVICE_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_SERVICE_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  serviceErrorEmailInUse: {
    header: INTL_IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
    text: INTL_IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_TEXT,
  },
  ssoLoanError: {
    header: INTL_IDS.REGISTER_SSO_LOAN_ERROR_HEADING,
    illustration: 'borrowerDesk',
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_SSO_LOAN_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  stepOneError: {
    header: INTL_IDS.REGISTER_STEP_ONE_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_STEP_ONE_ERROR_LINK_LABEL,
      path: { desktop: '/register', mobile: 'Register' },
    },
  },
  stepTwoError: {
    header: INTL_IDS.REGISTER_STEP_TWO_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_STEP_TWO_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  stepTwoValidationError: {
    header: INTL_IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_LINK_LABEL,
      path: { desktop: '/register', mobile: 'Register' },
    },
    text: INTL_IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_TEXT,
  },
  success: {
    header: INTL_IDS.REGISTER_SUCCESS_HEADING,
    isSuccess: true,
    link: {
      label: INTL_IDS.REGISTER_SUCCESS_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
    needsFormatting: true,
    text: 'Once the account is completed an email will be sent from <b>noreply@yourmortgageonline.com</b> that will provide instructions to complete registration.{{mobileParagraphSplit}}If you do not receive the email within 2 hours, please check your junk or spam folder prior to contacting Customer Service for further assistance.{{mobileParagraphSplit}}For questions, call <a>1-800-669-4268</a>.',
  },
  verifyError: {
    header: INTL_IDS.REGISTER_VERIFY_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.REGISTER_VERIFY_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  verifySuccess: {
    header: INTL_IDS.REGISTER_VERIFY_SUCCESS_HEADING,
    isSuccess: true,
    link: {
      label: INTL_IDS.REGISTER_VERIFY_SUCCESS_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
    text: 'Your account has been successfully registered. You may now log in with your username and password credentials.',
  },
};

export const GUIDED_VIEW_NAMESPACE_DICTIONARY = {
  1: 'guidedAccount',
  2: '',
};

export const REGISTER_VIEW_NAMESPACE_DICTIONARY = {
  1: 'initial',
  2: 'initial',
  3: 'initial',
  4: 'initial',
  5: 'consent',
  6: 'account',
  7: 'account',
  8: '',
  9: 'account',
};

export const SHARED_REGISTER_EMAIL_CARD_PROPS = {
  cardText: INTL_IDS.REGISTER_EMAIL_PARAGRAPH,
  cardTitle: INTL_IDS.REGISTER_EMAIL_HEADING,
  cardTooltip: false,
};

export const SHARED_REGISTER_LOAN_CARD_PROPS = {
  cardText: INTL_IDS.REGISTER_FORM_PARAGRAPH,
  cardTitle: INTL_IDS.REGISTER_FORM_HEADING,
  cardTooltip: false,
};

export const SHARED_REGISTER_RECAPTCHA_CARD_PROPS = {
  cardTitle: INTL_IDS.REGISTER_FORM_RECAPTCHA_HEADING,
  cardTooltip: false,
};

export const SHARED_REGISTER_RESEND_EMAIL_CARD_PROPS = {
  cardLinkText: 'Wrong Email?',
  cardText: INTL_IDS.REGISTER_RESEND_EMAIL_PARAGRAPH,
  cardTitle: INTL_IDS.REGISTER_RESEND_EMAIL_HEADING,
  cardTooltip: false,
};

export const SHARED_REGISTER_SSNTIN_CARD_PROPS = {
  cardText: INTL_IDS.REGISTER_FORM_SSN_PARAGRAPH,
  cardTitle: INTL_IDS.REGISTER_FORM_SSN_HEADING,
  cardTooltip: false,
};

export const SHARED_REGISTER_USERNAME_PASSWORD_CARD_PROPS = {
  cardText: INTL_IDS.REGISTER_CREATE_USERNAME_PASSWORD_PARAGRAPH,
  cardTitle: INTL_IDS.REGISTER_CREATE_USERNAME_PASSWORD_HEADING,
  cardTooltip: true,
  displayUsernameCriteria: true,
};

export const SHARED_REGISTER_ZIPCODE_CARD_PROPS = {
  cardText: INTL_IDS.REGISTER_FORM_ZIPCODE_PARAGRAPH,
  cardTitle: INTL_IDS.REGISTER_FORM_ZIPCODE_HEADING,
  cardTooltip: false,
};

/**
 * Constants used by username and password tool tips in registration flow
 */
export const SHARED_USERNAME_AND_PASSWORD_TOOLTIP_DATA = {
  password: {
    criteria: [
      '10 character minimum',
      '1 uppercase',
      '1 lowercase',
      '1 number',
      'Special characters may be used.',
    ],
    title: 'Password Requirements',
  },
  passwordLabel: 'Password Requirements',
  username: {
    criteria: [
      '5 character minimum',
      '25 character maximum',
      'No email address',
    ],
    title: 'Username Requirements',
  },
  usernameAndPasswordLabel: 'Username and Password Requirements',
};

// Consent & Reconsent
export const CONSENT_MESSAGE_DICT = {
  contactAcknowledgment: 'I have read, understand, and acknowledge receipt of the <button>ecommsPolicy</button>, and agree to its terms.',
  ecommsEstatementDesc: 'While using this Site, you may agree to a paperless option for receipt of certain loan information. By doing so, you shall receive certain documents and other communications via electronic means instead of mail. If you elect to receive any such items in this manner, any and all such communications are subject, respectively and as applicable, to the <button>ecommsPolicy</button> and the <button>estatementPolicy</button>.',
  electronicAcknowledgment: 'I have read, understand, and acknowledge receipt of the <button>estatementPolicy</button>, and agree to its terms.',
  privacyAcknowledgment: 'I have read, understand, and acknowledge receipt of the <button>privacyPolicy</button>.',
  privacyTermsDesc: 'Your use of this website (the “Site”) is governed by the <button>termsOfUse</button>. Additionally, your privacy is critically important to us, and we recognize and respect your privacy expectations and the requirements of applicable federal and state privacy laws. This <button>privacyPolicy</button> provides an explanation of how we collect, use and disclose personal information we receive from users of this Site, and the services offered through this Site.',
  termsAcknowledgment: 'I agree to these <button>termsOfUse</button>.',
};

export const CONSENT_BUTTON_LABEL_DICT = {
  ecommsPolicy: 'Electronic Communications Policy',
  estatementPolicy: 'E-Statement Policy',
  privacyPolicy: 'Privacy Policy',
  termsOfUse: 'Terms of Use',
};
